import React, { useState } from 'react';
import img1 from '../../../Assets/Ellipse 6.png';
import img2 from '../../../Assets/Ellipse 7.png';
import img3 from '../../../Assets/Ellipse 8.png';
import img4 from '../../../Assets/Ellipse 9.png';
import img5 from '../../../Assets/Ellipse 10.png';

const SafetyConsultants = () => {
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="grid grid-cols-12 justify-center p-8 mt-10 mb-12 bg-white">
      {/* Left side images (3 columns) */}
      <div className="col-span-12 md:col-span-4 px-5  hidden lg:flex">
        <div className="relative w-full h-full">
          {/* Main large image */}
          <div className="absolute xl:-top-10 xl:left-36 xl:w-32 xl:h-32 lg:-top-14 lg:left-16 lg:w-2 lg:h-32      md:-top-10 md:left-36 md:w-32 md:h-32  rounded-full overflow-hidden">
            <img
              src={img1}
              alt="Worker 1"
              className="object-cover w-full h-full"
            />
          </div>
          {/* Smaller images */}
          <div className="absolute xl:top-20  xl:left-24 xl:w-24 xl:h-24 lg:top-20 lg:left-5 lg:w-24 lg:h-24     md:-top-10 md:left-36 md:w-32 md:h-32   rounded-full overflow-hidden">
            <img
              src={img2}
              alt="Worker 2"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="absolute xl:top-20  xl:left-56 xl:w-20 xl:h-20 lg:top-20 lg:left-40 lg:w-20 lg:h-20  rounded-full overflow-hidden">
            <img
              src={img3}
              alt="Worker 3"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="absolute xl:top-40  xl:left-44 xl:w-20 xl:h-20 lg:top-40 lg:left-32 lg:w-20 lg:h-20  rounded-full overflow-hidden">
            <img
              src={img4}
              alt="Worker 4"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="absolute xl:top-52  xl:left-64 xl:w-12 xl:h-12 lg:top-52 lg:left-52 lg:w-20 lg:h-20  top-52 left-64 w-12 h-12 rounded-full overflow-hidden">
            <img
              src={img5}
              alt="Worker 5"
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>

      {/* Right side text content (8 columns) */}
      <div className="col-span-12 md:col-span-12 lg:col-span-8 flex flex-col justify-center">
        <h2 className="text-2xl md:text-3xl lg:text-[36px] font-semibold text-left md:text-left">
          Creative Safety Consultants (CSC)
        </h2>
        <p className="mt-2 text-lg md:text-[24px] text-gray-400 w-full md:w-[70%] mx-auto md:mx-0 text-left md:text-left">
          are experienced and dedicated health, safety, environmental (HSE)
          professionals who use their knowledge, skills, and experience to:
          Promote a positive health, safety, environmental culture across an
          organisation. Develop solutions to health, safety, and environmental
          challenges. Ensure workplace risks are well controlled.
          {showMore && (
            <>
              {' '}At CSC, we focus on improving workplace safety and ensuring
              the health of every worker. Our consultancy spans across various
              sectors, tailoring safety solutions to your needs.
            </>
          )}
        </p>

        <div className="mt-6 flex justify-start md:justify-start">
          <button
            onClick={handleShowMore}
            className="bg-[#F0940D] text-white py-2 px-4 rounded-lg shadow-lg hover:bg-[#e0830d] transition-all duration-300 w-full max-w-[300px]"
          >
            {showMore ? 'Show Less' : 'Show More'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SafetyConsultants;
